Backbone = require 'backbone'
BreadcrumbIndexTemplate = require '../../index.html.mustache'

module.exports = class BreadcrumbView extends Backbone.View
  BREADCRUMB_SELECTOR = '#breadcrumb-container'

  template: BreadcrumbIndexTemplate

  constructor: (@presenter) ->
    {breadcrumb} = @presenter
    return unless $(BREADCRUMB_SELECTOR).length

    $module = $(BREADCRUMB_SELECTOR)
    @$el = $module

  render: ->
    @$el.replaceWith @toHtml()

  toHtml: ->
    @template.render @presenter

  getSelector: ->
    selector = $(BREADCRUMB_SELECTOR)
    return selector if selector.length
